import { Component } from 'preact';

export default class Slider extends Component {
  defaultValue () {
    const { defaultValue, min, max } = this.props;
    return defaultValue || (max - min) / 2 + min;
  }

  value () {
    const inputValue = this.input && Number(this.input.value);

    if (!isNaN(inputValue)) {
      return inputValue;
    }

    if (!isNaN(this.props.value)) {
      return this.props.value;
    }

    return this.defaultValue();
  }

  onInput = () => {
    if (this.props.onInput) {
      this.props.onInput(this.value());
    }
  }

  onChange = () => {
    if (this.props.onChange) {
      this.props.onChange(this.value());
    }
  }

  shouldComponentUpdate (nextProps) {
    if (this.props.value !== nextProps.value && this.input) {
      this.input.value = nextProps.value;
    }

    return this.props.defaultValue !== nextProps.defaultValue ||
      this.props.min !== nextProps.min ||
      this.props.max !== nextProps.max ||
      this.props.visible !== nextProps.visible;
  }

  componentDidMount () {
    const { autofocus } = this.props;
    
    if (autofocus) {
      this.input.focus();
    }
  }

  moveStart = (event) => {
    let { screenX, touches } = event;

    event.preventDefault();

    // console.log('moveStart');

    if (screenX === undefined && touches && touches.length) {
      screenX = touches[0].screenX;
    }

    this.moveStartX = screenX;
    this.moveStartValue = Number(this.input.value);
    window.addEventListener('mousemove', this.move);
    window.addEventListener('mouseup', this.moveEnd);
    window.addEventListener('touchmove', this.move);
    window.addEventListener('touchend', this.moveEnd);

    this.input.focus();
  }

  moveEnd = () => {
    // console.log('moveEnd');

    this.moveStartX = undefined;
    this.moveStartValue = undefined;
    window.removeEventListener('mousemove', this.move);
    window.removeEventListener('mouseup', this.moveEnd);
    window.removeEventListener('touchmove', this.move);
    window.removeEventListener('touchend', this.moveEnd);

    this.input.focus();
  }

  move = (event) => {
    let { buttons, screenX, touches } = event;

    event.preventDefault();


    if (screenX === undefined && touches && touches.length) {
      screenX = touches[0].screenX;
      buttons = 1;
    }

    // console.log('move', buttons, screenX);

    if (buttons === 1 && this.moveStartX !== undefined && this.gradation) {
      const width = this.gradation.width.baseVal.value;
      const { min, max, step = 1 } = this.props;
      const numSteps = (max - min) / step;
      const stepWidth = width / (numSteps - 1);
      const stepChange = Math.round((screenX - this.moveStartX) / stepWidth);

      if (stepChange) {
        let newValue = this.moveStartValue + stepChange;

        if (newValue < min) {
          newValue = min;
        }

        else if (newValue > max) {
          newValue = max;
        }

        const currentValue = Number(this.input.value);

        if (newValue !== currentValue) {
          this.input.value = newValue;
          this.moveOriginX = screenX;

          if (this.props.onInput) {
            this.onInput();
          }

          else if (this.props.onChange) {
            this.onChange();
          }
        }
      }
    }
  }

  renderGradation (value) {
    // TODO move defs to index, once min/max years known
    const { min, max, step = 1 } = this.props;
    const valueRatio = (value - min) / (max - min);

    // const numSteps = Math.floor((max - min) / step) + 1;
    const numSteps = (max - min) / step;
    const stepWidthPercent = 100 / (numSteps - 1);
    const valueSteps = valueRatio && 1 / (numSteps * valueRatio);
    const valueWidthPercentString = valueRatio * 100 + '%';

    const lines = [];

    // console.log('renderGradation', {numSteps, stepWidth, valueWidthPercent})

    // for (let i = 0; i < numLines; i++) {
    //   const x = stepWidth * i + '%';

    //   lines.push(
    //     <line x1={ x } y1="25%" x2={ x } y2="75%" stroke="#003366" stroke-width="1"/>
    //   );
    // }

    return <svg class="gradation" ref={gradation => this.gradation = gradation}>
      <defs>
        <pattern id="Slider-gradation-step" width={ valueSteps } height="100%">
          {/*<line x1="50%" y1="25%" x2="50%" y2="75%" stroke="#003366" stroke-width="1"/>*/}
          <line x1={ stepWidthPercent / 2} y1="25%" x2={ stepWidthPercent / 2} y2="75%" stroke="#003366" stroke-width="1"/>
        </pattern>
      </defs>

      <g class="gradation-fill">
        {/* <rect width={ valueWidthPercentString } height="100%" fill="#BCCCD8"/> */}
        <rect width={ valueWidthPercentString } height="100%" fill="url(#Slider-gradation-step)"/>
      </g>
    </svg>;
  }

  render (props) {
    const { min, max, step = 1, onInput, onChange, autofocus = false, marker, gradation, thumb, buttons, onIncrease, onDecrease, visible = true } = props;

    if (!min || !max) {
      return null;
    }


    const className = `Slider ${props.class || props.className || ''}`;
    // const defaultValue = value || (max - min) / 2 + min;
    const value = this.value();
    const valueRatio = (value - min) / (max - min);
    const markerXPercent = marker && Math.round(valueRatio * 100);

    // console.log('slider render', { min, max, value });

    return <div class={ className }>
      {
        gradation && this.renderGradation(value)
      }

      { marker && 
        <span class="marker-container">
          <span
            class="marker"
            onTouchStart={ this.moveStart }
            onMouseDown={ this.moveStart }
            style={`left: ${ markerXPercent }%;`}>
              { value }
            </span>
        </span>
      }

      { buttons && <svg class="buttons">
          <g class="button">
            <rect width="22" height="22" fill="none"/>
            <text x="11" y="16.5" onClick={ onDecrease }>－</text>
          </g>

          <g class="button">
            <rect width="22" height="22" fill="none"/>
            <text x="11" y="16.5" onClick={ onIncrease }>＋</text>
          </g>
        </svg>
      }

      <input
        type="range"
        min={ min }
        max={ max }
        step={ step }
        autofocus={ autofocus }
        defaultValue={ this.defaultValue() }
        onInput={ onInput && this.onInput }
        onChange={ onChange && this.onChange }
        ref={ input => this.input = input }
        tabIndex={ visible ? 0 : -1 }
      />

      { thumb && 
        <svg class="thumb-container"
          width="30"
          height="32"
          style={ `margin-left: calc(${ markerXPercent }% - ${ (valueRatio * 30).toFixed(1) }px - ${ valueRatio.toFixed(1) }rem)` }
          onTouchStart={ this.moveStart }
          onMouseDown={ this.moveStart }
        >
          <rect x="2" y="2" class="thumb" width="26" height="28" fill="#003366" stroke-width="2" stroke="#003366"></rect>
          <path stroke="#7997B3" stroke-width="1" d="M12 10 v12 m2 -12 v12 m2 -12 v12 m2 -12 v12" />
        </svg>
      }
    </div>;
  }
}



// WEBPACK FOOTER //
// ./components/Slider.js